import { Component, OnInit, OnDestroy, Input, AfterViewInit, ViewChild, ElementRef } from "@angular/core";
import { HttpCalendarService } from "@root/component/multi-calendar/http-calendar.service";
import { HouseStatusService } from "@root/router/deprecated_and_do_not_use-house/house-status/house-status.service";
import * as moment from "moment";
import { Subscription, merge, Subject, fromEvent } from "rxjs";
import _, { find, head, keyBy, last, mapValues } from "lodash";
import { tap, takeUntil, distinctUntilChanged, take, skip, debounceTime } from "rxjs";
import { WritePermissionGurd } from "@root/util/decorator";
import { ModalService } from "@root/router/index/modal.service";
import {
  PriceChild,
  Parent,
  MultiHouseCalendarService,
  DateRange,
} from "@root/router/component/calendar/multi-house-calendar/multi-house-calendar.service";
import { HttpClient } from "@angular/common/http";
import { differenceInDays, isSameDay, parse, subDays } from "date-fns";
import { NzDrawerRef } from "ng-zorro-antd/drawer";
import { CdkScrollable, ScrollDispatcher } from "@angular/cdk/overlay";

@Component({
  selector: "host-single-price-calendar-v2",
  templateUrl: "./single-price-calendar-v2.component.html",
  styleUrls: ["./single-price-calendar-v2.component.scss"],
})
export class SinglePriceCalendarV2Component implements OnInit, AfterViewInit, OnDestroy {
  private readonly CalendarApi = "/api/calendar/v3_price_calendar";
  @ViewChild("calendarContainer", { static: true }) calendarContainer: ElementRef;
  @ViewChild("scrollContainer") scrollContainerV2: ElementRef;
  @Input() type: "house" | "type" = "house";
  @Input() id;
  @Input() unique_key;
  priceInfo;
  currentMonth = moment().format("YYYY-MM");
  // listOfDateOptions = this.multiCalendarService.getAllMonth();
  listOfChannelHouse: PriceChild[] = []; // 代表渠道列表
  listOfMonthOption = [];
  inviewedMonth: Set<string> = new Set();
  houseEntity: Parent;
  currentCurrency = "CNY";

  listOfSelectedDates: DateRange = {
    head: null,
    last: null,
  };

  selectStatus: "done" | "none" | "doing" = "none";

  channelHouse: Partial<PriceChild>;

  calendarMap = {};
  reservationMap = {};
  channelColorMap = {};
  // selectStatus = {
  //   status: 'none',
  //   dates: null,
  // };

  selectedReservation = null;

  channelSidebarDrawerRef;
  private selected$ = this.houseCalendarService.selectRaw$.pipe(
    tap((value) => {
      // this.selectStatus = value;

      if (value.status !== "done") {
        this.channelSidebarDrawerRef?.close();
        this.offsetDrawerRef(0);

        this.listOfSelectedDates = {
          head: null,
          last: null,
        };
        this.selectStatus = "none";
      }
      return;
      if (value.status === "done") {
        this.channelSidebarDrawerRef = this.gms.displayChannelSidebar();
        this.offsetDrawerRef(320);
      } else {
        this.channelSidebarDrawerRef?.close();
        this.offsetDrawerRef(0);
      }

      // if (value.status !== 'none') {
      //   this.houseCalendarService.cancelSelectReservation();
      // }
    }),
  );

  private calendarRefresh$ = this.houseCalendarService.calendarRefreshRaw$;

  private dateChangeRaw$ = new Subject<{
    type: "month" | "year";
    date: string;
  }>();
  private dateChange$ = this.dateChangeRaw$.pipe(
    distinctUntilChanged(),
    tap((value) => {
      this.currentMonth = value.date;
      // this.listOfDateOptions =
      //   value.type === "month"
      //     ? this.multiCalendarService.getAllMonth()
      //     : this.multiCalendarService.getAllYear();
    }),
  );

  private destroy$ = new Subject();

  get uniqueKey() {
    return this.channelHouse?.c_id;
  }

  get thirdpartyType() {
    return this.channelHouse?.thirdparty_type;
  }

  constructor(
    private gms: ModalService,
    private calendarService: HttpCalendarService,
    private houseStatusService: HouseStatusService,
    private houseCalendarService: MultiHouseCalendarService,
    private http: HttpClient,
    private drawerRef: NzDrawerRef,
    private scrollDispatcher: ScrollDispatcher,
  ) {}

  ngOnInit() {
    // this.fetchHouseCalendar();
    // this.requestThirdparties().subscribe();

    this.selected$.pipe(takeUntil(this.destroy$)).subscribe(() => {
      console.log("selected$");
    });

    this.calendarRefresh$.pipe(takeUntil(this.destroy$)).subscribe((res) => {
      this.fetchCalendarV2();
      // this.fetchHouseCalendar();
      console.log("calendarRefresh$");
    });

    this.dateChange$.pipe(takeUntil(this.destroy$)).subscribe((res) => {
      // this.getHouseCalendarByMonth();
      console.log("dateChange$");
      this.fetchCalendarV2();
      // this.fetchHouseCalendar();
    });

    this.listOfMonthOption = this.initMonthOptions();
    if (this.id) {
      this.fetchHouseList();
    }
  }

  ngAfterViewInit() {
    let id = setTimeout(() => {
      this.subscribeScrollEvent();
      this.scrollTo(this.currentMonth);

      // this.subscribeContainerScroll();
      clearTimeout(id);
      id = null;
    }, 500);
  }

  private offsetDrawerRef(value: number) {
    if (this.drawerRef) {
      this.drawerRef.nzOffsetX = value;
    }
  }

  private fetchHouseList() {
    const params = {
      page: 1,
      page_size: 100,
      version: "2.4",
      type: "house_price",
    };
    if (this.type === "house") {
      _.assign(params, { house_id: this.id });
    } else {
      _.assign(params, { house_type_id: this.id });
    }
    this.calendarService.getHouseListV2(params).subscribe((res) => {
      console.log("fetch house list: ", res);
      const keyList = _.get(res, "data.list");
      const houseTypeMap = _.get(res, "data.map");

      // this.listOfChannelHouse = keyList;
      this.houseEntity = this.updateHouseEntity(keyList, _.head(houseTypeMap));
      this.listOfChannelHouse = this.houseEntity?.p_children as PriceChild[];

      if (this.unique_key) {
        const house = this.listOfChannelHouse.find((item) => item.c_id === this.unique_key);
        this.onChannelHouseChange(house);
      } else {
        this.onChannelHouseChange(_.head(this.listOfChannelHouse));
      }

      console.log("relatedHouseinfo: ", this.houseEntity);
    });
  }

  private fetchCalendarV2() {
    const begin = moment(head(this.listOfMonthOption), "YYYY-MM").startOf("month").format("YYYY-MM-DD");
    const end = moment(last(this.listOfMonthOption), "YYYY-MM").endOf("month").format("YYYY-MM-DD");
    const unique_keys = JSON.stringify([this.uniqueKey]);
    const params = {
      begin,
      end,
      unique_keys,
    };
    this.http.get(this.CalendarApi, { params }).subscribe((rst: any) => {
      const calendar = rst?.data?.list?.[0]?.calendar;
      const resvs = rst?.data?.reservations;

      this.calendarMap = this.generateResvInfo(this.generateCalendarInfo(calendar), resvs);
      console.log("calendarmap: ", this.calendarMap);
    });
  }

  private generateCalendarInfo(calendar: any[]) {
    return mapValues(keyBy(calendar, "date"), (item) => {
      const { setting } = item;
      if (setting) {
        item.setting = {
          ...setting,
          showMoon: setting.min_stay_on_arrival || setting.min_stay_through,
          // ||
          // setting.max_stay_on_arrival ||
          // setting.max_stay_through ||
          // setting.exact_stay_on_arrival,
          moonCount: Math.max(setting.min_stay_on_arrival || 0, setting.min_stay_through || 0),
          showFlag: setting.min_advance_res || setting.max_advance_res || setting.seasonal_rule,
          showLock: setting.closed_on_arrival || setting.closed_on_departure,
        };
      }
      return item;
    });
  }

  private generateResvInfo(calendarMap, resvs: any[]) {
    return mapValues(calendarMap, (calendar) => {
      // 生成订单信息
      const code = calendar.reservation;
      const resv = find(resvs, { origin_code: code });
      if (resv) {
        const { check_in, check_out } = resv;

        return {
          ...calendar,
          resv: resv,
          resvHead: calendar.date === check_in,
          resvLast: isSameDay(
            subDays(parse(check_out, "yyyy-MM-dd", new Date()), 1),
            parse(calendar.date, "yyyy-MM-dd", new Date()),
          ),
          resvNights: differenceInDays(new Date(check_out), new Date(check_in)),
        };
      }
      return calendar;
    });
  }

  private updateHouseEntity(keyList, house) {
    console.log("update related house info house: ", house);
    const parent: Parent = this.houseCalendarService.generatePriceParentEntity(house);
    const children = keyList.map((item) => this.houseCalendarService.generatePriceChildEntiry(item, parent));
    parent.p_children = children;

    console.log("houseEntity: ", parent);
    return parent;
  }

  @WritePermissionGurd("calendar")
  synchroniseCalendar() {
    const params = this.type === "house" ? { house_id: this.id } : { house_type_id: this.id };
    this.houseStatusService.syncCalendar(params).subscribe((res) => {
      if (res.error_code === 0) {
      }
    });
  }

  @WritePermissionGurd("calendar")
  onClickChangeAvailable(data) {
    console.log("onclickchangeavailable:", data);
    this.houseCalendarService.requestUpdateChannelAvailable(data.status, this.thirdpartyType);
    // this.requestChangeHouseAvailable(data);
  }

  @WritePermissionGurd("calendar")
  onClickChangeTab(name) {
    this.houseCalendarService.changeTab(name);
  }

  /**
   * 显示未来12个月 + 之前的4个月（包含本月）
   */
  private initMonthOptions() {
    // const month = moment().month();
    const result = [];

    const start = moment().subtract(12, "month").date(1);
    const end = moment().add(2, "year").date(1);

    while (start.isSameOrBefore(end, "month")) {
      result.push(start.format("YYYY-MM"));
      start.add(1, "month");
    }
    console.log("result: ", result);
    return result;
  }

  private scrollTo(month: string) {
    const index = this.listOfMonthOption.indexOf(month);

    if (index !== -1) {
      const container = this.scrollContainerV2.nativeElement;
      const clientOffsetTop = container.offsetTop;

      const items = container.querySelectorAll(".calendar-item");
      const indexedDom = items[index];

      indexedDom?.scrollIntoView();
    }
  }

  private findInviewdItems(
    container: {
      top: number;
      height: number;
    },
    item: HTMLElement,
  ) {
    const itemRect = item.getBoundingClientRect();
    const { top, height } = itemRect;

    const month = item.dataset.month;

    if (top + height >= container.top && top <= container.top + container.height) {
      console.log(month + " in view");
      this.inviewedMonth.add(month);
    } else {
      this.inviewedMonth.delete(month);
    }

    // if (itemTop + 238 + )

    console.log(month + " itemtop: ", itemRect, " scrollTop: ", container);
  }

  subscribeScrollEvent() {
    const container = this.scrollContainerV2.nativeElement;
    fromEvent(container, "scroll")
      .pipe(debounceTime(300), takeUntil(this.destroy$))
      .subscribe((event) => {
        const containerRect = container.getBoundingClientRect();
        // 获取所有需要监测的元素
        const elements: HTMLElement[] = Array.from(container.querySelectorAll(".calendar-skeleton"));

        // 开始监测每个元素
        elements.forEach((element) => {
          this.findInviewdItems(
            {
              top: containerRect.top,
              height: containerRect.height,
            },
            element,
          );
        });
      });

    // return;

    // this.scrollDispatcher.scrolled(300).subscribe((rst: CdkScrollable) => {
    //   const containerRect = rst.getElementRef().nativeElement.getBoundingClientRect();
    //   // 获取所有需要监测的元素
    //   const elements: HTMLElement[] = Array.from(
    //     this.calendarContainer.nativeElement.querySelectorAll(".calendar-skeleton"),
    //   );

    //   console.log("elementes: ", elements);
    //   // 开始监测每个元素
    //   elements.forEach((element) => {
    //     this.findInviewdItems(
    //       {
    //         top: containerRect.top,
    //         height: containerRect.height,
    //       },
    //       element,
    //     );
    //   });
    // });
  }

  onSelectCell(data) {
    this.listOfSelectedDates = data.dates;
    this.selectStatus = data.status;
    if (data.status === "done") {
      this.channelSidebarDrawerRef = this.gms.displayChannelSidebar({ selectedData: data });
      this.offsetDrawerRef(320);
    } else {
      this.channelSidebarDrawerRef?.close();
      this.offsetDrawerRef(0);
    }
  }

  onMonthChange(month: string) {
    this.scrollTo(month);
  }

  onChannelHouseChange(value) {
    this.channelHouse = value;

    this.calendarMap = {};
    this.fetchCalendarV2();
  }

  ngOnDestroy() {
    this.destroy$.next(null);
    this.destroy$.complete();

    this.offsetDrawerRef(0);
    this.channelSidebarDrawerRef?.close();
  }
}
